import PropTypes from 'prop-types'

import React, { Component } from 'react'
import { navigate } from 'gatsby'

import Modal from './Modal'
import Card from './Card'

import { hasTags } from './utilities'

class PostRelatedCard extends Component {
    constructor(props) {
        super(props)
        this.state = { showModal: false }
        this.handleClick = this.handleClick.bind(this)
        this.modalClose = this.modalClose.bind(this)
    }

    handleClick(url) {
        if (url) {
            navigate(url)
        } else {
            this.setState({ showModal: !this.state.showModal })
        }
    }

    modalClose() {
        this.setState({ showModal: false })
    }

    render() {
        const { post } = this.props
        const { showModal } = this.state
        const url = `/${post.slug}/`

        let isPost = hasTags(post.tags, ['post', 'hash-post'])

        return (
            isPost && (
                <div>
                    <div className="card post-related-card">
                        <Card post={post} click={this.handleClick} url={url} />
                    </div>
                    <Modal
                        showModal={showModal}
                        post={post}
                        modalClose={this.modalClose}
                    />
                </div>
            )
        )
    }
}

PostRelatedCard.propTypes = {
    post: PropTypes.shape({
        slug: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        feature_image: PropTypes.string,
        featured: PropTypes.bool,
        tags: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
            })
        ),
        excerpt: PropTypes.string.isRequired,
        primary_author: PropTypes.shape({
            name: PropTypes.string.isRequired,
            profile_image: PropTypes.string,
            slug: PropTypes.string,
        }).isRequired,
    }).isRequired,
}

export default PostRelatedCard
